<template>
  <div>
    <filter-bar v-if="!nofilter"></filter-bar>
    <div class="vuetable-pagination" >
      <ck-vuetable-pagination-info ref="paginationInfo"
        class="font-numbers"
        info-class="pagination-info"
        info-template="{from} bis {to} von {total}"
      ></ck-vuetable-pagination-info>
      <vuetable-pagination ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
    <vuetable ref="vuetable"
      :fields="fields"
      :api-url="apidata"
      :columns="columns"
      pagination-path=""
      :css="css.table"
      :sort-order="defaultsortorder"
      :multi-sort="true"
      :detail-row-component="detailrow"
      :append-params="moreParams"
      :per-page="parseInt(perpage)"
      @vuetable:cell-clicked="onCellClicked"
      @vuetable:pagination-data="onPaginationData"
    >
      <template v-if="modeltype == 'player'" slot="playerActions" slot-scope="props">
        <a class="vt-actionLink" :href="'/player/profile/' + ((props.rowData) ? props.rowData.id : '')"><i class="fa fa-eye"></i></a>
        <a v-if="props.rowData.email" class="vt-actionLink" :href="'mailto:' + props.rowData.email"><i class="fa fa-envelope"></i></a>
        <span v-if="!props.rowData.email" class="vt-actionLink has-text-color-grey"><i class="fa fa-envelope"></i></span>
        <a v-if="props.rowData.phone" class="vt-actionLink" :href="'tel:' + props.rowData.phone"><i class="fa fa-phone"></i></a>
        <span v-if="!props.rowData.phone" class="vt-actionLink has-text-color-grey"><i class="fa fa-phone"></i></span>

      </template>
      <template v-if="modeltype == 'contact'" slot="playerFullname" slot-scope="props">
        <a :href="'/player/profile/' + props.rowData.player_id + '?tab=contacts'">{{ props.rowData.firstname + ' ' + props.rowData.lastname}}</a>
      </template>
      <template slot="partnerActions" slot-scope="props">
        <a class="has-padding-left-0-5 has-padding-right-0-5" :href="'/' + props.rowData.partnertype + '/' + props.rowData.id"><i class="fa fa-eye"></i></a>
        <a v-if="props.rowData.email" class="has-padding-left-0-5 has-padding-right-0-5" :href="'mailto:' + props.rowData.email"><i class="fa fa-envelope"></i></a>
        <span v-if="!props.rowData.email" class="has-padding-left-0-5 has-padding-right-0-5 has-text-color-grey"><i class="fa fa-envelope"></i></span>
        <a class="has-padding-left-0-5 has-padding-right-0-5 has-text-danger" :href="'/delete/' + props.rowData.partnertype + '/' + props.rowData.id"><i class="fa fa-trash"></i></a>
        <span
          :class="{'has-padding-left-0-5 has-padding-right-0-5': true, 'has-text-success' : props.rowData.user_active}" v-if="props.rowData.user_id"
          >
          <i class="fa fa-user"></i>
        </span>
      </template>
      <template slot="contactActions" slot-scope="props">
        <a :href="'/contacts/' + props.rowData.id" ><i class="fa fa-edit"></i></a>
        <a :href="'/contacts/delete/' + props.rowData.id" class="has-text-danger has-margin-left-0-5"><i class="fa fa-trash "></i></a>
      </template>
      <template slot="accountingActions" slot-scope="props">
        <a :href="'/accountings/edit/' + props.rowData.id"><i class="fa fa-edit"></i></a>
        <a :href="'/accountings/delete/' + props.rowData.id" ><i class="has-margin-left-0-5 fa fa-trash has-text-danger"></i></a>
        <a :href="'/files/' + props.rowData.file_id" v-if="props.rowData.file_id" ><i class="has-margin-left-0-5 fa fa-download"></i></a>
      </template>
      <template slot="accountingOverviewActions" slot-scope="props">
        <a class="vt-actionLink" :href="'/player/profile/' + ((props.rowData) ? props.rowData.id : '') + '?tab=accounting'"><i class="fa fa-eye"></i></a>
        <a :href="'/accountings/new/'+ props.rowData.id"><i class="fa fa-plus has-margin-left-0-5"></i></a>
      </template>
    </vuetable>
  </div>
</template>

<script>
import accounting from 'accounting'
import moment from 'moment'
import Vuetable from './Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import Vue from 'vue'
import ckVuetablePaginationInfo from './PaginationInfo'
import VueEvents from 'vue-events'
import CustomActions from './Players/CustomActions'
import PlayerDetailRow from './Players/DetailRow'
import ContactListDetailRow from './contactListDetailRow'
import FilterBar from './FilterBar'

Vue.use(VueEvents)
Vue.component('custom-actions', CustomActions)
Vue.component('player-detail-row', PlayerDetailRow)
Vue.component('contact-detail-row', ContactListDetailRow)
Vue.component('filter-bar', FilterBar)

export default {
  components: {
    ContactListDetailRow,
    Vuetable,
    VuetablePagination,
    ckVuetablePaginationInfo,
  },
  props: [
    'perpage',
    'apidata',
    'fields',
    'columns',
    'modeltype',
    'detailrow',
    'defaultsortorder',
    'nofilter',
    'responsivedetail'
  ],
  data () {
    return {
      css: {
        table: {
          tableClass: 'table is-bordered is-striped is-narrow is-hovererable is-fullwidth is-responsive',
          ascendingIcon: 'fa fa-chevron-up',
          descendingIcon: 'fa fa-chevron-down'
        },
        pagination: {
          wrapperClass: 'pagination',
          activeClass: 'is-active',
          disabledClass: 'is-disabled',
          pageClass: 'page',
          linkClass: 'link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
        icons: {
          first: 'fa fa-step-backward',
          prev: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right',
          last: 'fa fa-step-forward',
        },
      },
      sortOrder: [
        this.defaultsortorder
      ],
      moreParams: {
        'modeltype': this.modeltype
      },
      contactsVisible: false
    }
  },
  methods: {
    allcap (value) {
      return value.toUpperCase()
    },
    partnerAdded () {
      this.eventHub.$on('addedPartner', data => {
        console.log('addedPartner');
      })
    },
    genderLabel (value) {
      return value === 'M'
        ? '<span class="label label-success"><i class="glyphicon glyphicon-star"></i> Male</span>'
        : '<span class="label label-danger"><i class="glyphicon glyphicon-heart"></i> Female</span>'
    },
    formatNumber (value, type) {
      let _number = value;
      let _classValue = 'has-text-success';
      if (parseFloat(_number) < 0 || type === 'expense') {
        _classValue = 'has-text-danger'
      }

      return `<span class="${_classValue}">€ ${_number}</span>`;
    },
    replaceEmpty (value) {
      return (value === null) ? '&nbsp;' : value;
    },
    formatAmount (value) {
      return '€ ' + value;
    },
    renameIncomeExpense (value) {
      if (value === 'income') return 'Einnahme'
      if (value === 'expense') return 'Aufwand'
    },
    formatDate (value, fmt = 'DD.MM.YYYY') {
      return (value == null)
        ? ''
        : moment(value, 'YYYY-MM-DD').format(fmt)
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    formatLongText(value) {
      let returnValue = '';
      let valueArr = value.split(/[\n]/g);
      if (valueArr.length === 1 && window.innerWidth >= 1024) {
        return `<p class="table-text"> ${valueArr[0]}</p>`
      }

      if (window.innerWidth >= 1024) {
        valueArr.forEach(x => {
          return returnValue += `<p class="table-text"> ${x} </p>`
        });
        return returnValue;
      }

      return value.substring(0, 30) + '&hellip;'
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onCellClicked (data, field, event) {
      if (this.detailrow !== 'false') {
        if(this.responsivedetail === 'true') {
          if (window.innerWidth >= 1024) return;
        }
        this.$refs.vuetable.toggleDetailRow(data.id)
      }
    }
  },
  events: {
    'filter-set' (filterText) {
      this.moreParams = {
        filter: filterText
      }
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
    },
    'filter-reset' () {
      this.moreParams = {}
      Vue.nextTick( () => this.$refs.vuetable.refresh() )
    },
    'close-detailrow' (data) {
      this.$refs.vuetable.toggleDetailRow(data.id)
    }
  }
}
</script>
<style>
.pagination {
  display: flex;
  justify-content: flex-end;
}
.pagination a.page {
  border: 1px solid lightgray;
  padding: 5px 10px;
  margin-right: 2px;
}
.pagination a.page.active {
  color: white;
  background-color: #337ab7;
  border: 1px solid lightgray;
  padding: 5px 10px;
  margin-right: 2px;
}
.pagination a.btn-nav {
  border: 1px solid lightgray;
  padding: 5px 7px;
  margin-right: 2px;
}
.pagination a.btn-nav.disabled {
  color: lightgray;
  border: 1px solid lightgray;
  padding: 5px 7px;
  margin-right: 2px;
  cursor: not-allowed;
}
.pagination-info {
}
.vuetable-pagination {
  display: flex;
  justify-content: space-between;
}

.vt-actionLink {
  margin-left: 0.3rem;
  font-size: 1.1rem;
}

.ck_change-contact {
  position: absolute;
  width: 300px;
  height: 100%;
  left: calc(50% - 150px);
  top: 0;
}

@media screen and (max-width: 1023px) {
  .vuetable-pagination {
    flex-wrap: wrap;
    justify-content: center;
    margin: 1rem 0;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/CkVuetable.vue